<div class="cx-my-account-v2-user">
  <ng-container *ngIf="user$ | async as user">
    <div class="cx-name">{{ user.title }}{{ user.name }}</div>
    <a
      class="cx-sign-out"
      [routerLink]="
        {
          cxRoute: 'logout',
        } | cxUrl
      "
      >{{ 'myAccountV2User.signOut' | cxTranslate }}
    </a>
  </ng-container>
</div>
